import { deriveShiftStatus } from "./shiftHelpers";

export function searchFilterShifts(shifts, searchTerm, statusFilter = "All", locationFilter = "All") {
  if (!Array.isArray(shifts) || shifts.length === 0) return [];

  const term = (searchTerm || "")
    .replace(/[^a-zA-Z0-9\s\-_.]/g, "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

  return shifts.filter((shift) => {
    const matchesSearch =
      !term ||
      shift.userName?.toLowerCase().includes(term) ||
      shift.shiftNumber?.toLowerCase().includes(term) ||
      shift.location?.toLowerCase().includes(term) ||
      shift.counter?.toLowerCase().includes(term);

    const matchesStatus =
      statusFilter === "All" || deriveShiftStatus(shift) === statusFilter.toLowerCase();

    const matchesLocation =
      locationFilter === "All" || shift.location === locationFilter;

    return matchesSearch && matchesStatus && matchesLocation;
  });
}
